/**
 * Projects Entity Configuration
 *
 * Defines entity-specific configuration for Projects list view
 * including API hooks, routes, labels, status mappings, and filter options.
 */

import { useProjects, useProject } from "../../../hooks/useApi";

const ProjectsConfig = {
  // Entity identification
  entity: "projects",
  entitySingular: "Project",
  entityPlural: "Projects",

  // API configuration
  hooks: {
    useEntities: useProjects,
    useEntity: useProject,
  },

  // Routing configuration
  routes: {
    list: "/projects",
    detail: "/project/:id",
    new: "/new-project",
    edit: "/project/:id/edit",
  },

  // Status configuration
  statusOptions: [
    { value: "planning", label: "Planning", color: "blue" },
    { value: "active", label: "Active", color: "green" },
    { value: "completed", label: "Completed", color: "gray" },
    { value: "on-hold", label: "On Hold", color: "yellow" },
    { value: "cancelled", label: "Cancelled", color: "red" },
  ],

  // Filter configuration
  filterFields: ["status", "type", "location"],
  searchFields: ["project_name", "description", "location", "project_type"],

  // Display configuration
  primaryField: "project_name",
  secondaryField: "description",

  // Icon and category mappings
  categoryIcons: {
    residential: "home",
    commercial: "building",
    "mixed-use": "buildings",
    industrial: "factory",
    land: "map",
  },

  // Default layout preference
  defaultLayout: "table",

  // Empty state configuration
  emptyState: {
    title: "No projects found",
    description: "Get started by creating your first project",
    actionText: "Create New Project",
    actionRoute: "/new-project",
  },

  // Feature flags
  features: {
    hasCategories: true,
    hasStatusBadges: true,
    hasProgressIndicators: true,
    hasQuickActions: true,
    supportsBulkActions: false,
  },
};

export default ProjectsConfig;
